import React from "react";
import boyimg from '../asset/boyimg2.png';
import bgImage from '../asset/bgimage.png'

export default function WhatSkillara() {
  return (
    <section className="w-full py-16 px-6 md:px-12 lg:px-20 overflow-hidden relative">
      <div 
        className="absolute inset-0 -z-10 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${bgImage})`, // CHANGE THIS PATH
        }}
      />
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

        {/* LEFT SIDE IMAGE SECTION */}
        <div className="relative flex justify-center md:justify-start order-2 md:order-1">
          
          {/* Boy Image - Responsive width */}
          <img
            src={boyimg}
            alt="Student"
            className="w-64 sm:w-80 md:w-[600px] relative z-10"
          />
        </div>

        {/* RIGHT SIDE TEXT SECTION */}
        <div className="w-full text-center md:text-left order-1 md:order-2">
   <h2 className="text-4xl font-extrabold text-blue-900 dark:text-white">
            What Students Gain
            <span className="absolute left-0 -bottom-2 w-full h-[4px] bg-gradient-to-r from-[#1c3664] to-transparent"></span>
          </h2>

          <p className="text-[#0db670] text-lg mb-6 italic px-4 md:px-0">
            “Not just training a launchpad to your Tech career.”
          </p>

          <ul className="space-y-4 md:space-y-5 text-base sm:text-lg md:text-xl max-w-2xl mx-auto md:mx-0">

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">Practical, job-ready skills</span>
            </li>

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">A strong project portfolio</span>
            </li>

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">Industry-relevant knowledge</span>
            </li>

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">Internship-style training and exposure</span>
            </li>

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">Certification that supports placements</span>
            </li>

            <li className="flex items-start gap-3 justify-start">
              <span className="w-7 h-7 flex items-center justify-center bg-[#1c3664] rounded-md shadow-md text-white text-lg flex-shrink-0">
                ✔
              </span>
              <span className="text-[#1c3664]">
               Improved confidence in technical & professional
              </span>
            </li>

          </ul>
        </div>
      </div>
    </section>
  );
}